/**
 * GroupBy
 * @author ftgibran
 */
export enum GroupBy {
  VAZIO = 'Nenhum',
  ID_CARGA = 'ID_CARGA',
  CTE = 'CTE',
}
